export interface IErrorDescription {
  id: number;
  name: string;

  error?(): void;
}

export const BI_ERRORS = {
  // last 1516
  genericError: {
    id: 1515,
    name: 'genericError',
    error() {
      throw new Error(this.name);
    },
  },
  tpa: {
    wix: {
      siteInfo: {
        get: {
          id: 1501,
          name: 'tpa.wix.siteInfo.get',
          error() {
            throw new Error(this.name);
          },
        },
      },
      activities: {
        getUserSessionToken: {
          id: 1502,
          name: 'tpa.wix.activities.getUserSessionToken',
          error() {
            throw new Error(this.name);
          },
        },
      },
    },
  },
  widget: {
    musicAlbum: {
      get: {
        id: 1001,
        name: 'widget.musicAlbum.get',
        error() {
          throw new Error(this.name);
        },
      },
      invalidId: {
        id: 1514,
        name: 'widget.musicAlbum.invalidId',
        error() {
          throw new Error(this.name);
        },
      },
    },
    unhandled: {
      rejection: {
        id: 1503,
        name: 'widget.unhandled.rejection',
        error() {
          throw new Error(this.name);
        },
      },
    },
    bi: {
      send: {
        id: 1504,
        name: 'widget.bi.send',
        error() {
          throw new Error(this.name);
        },
      },
    },
    statistic: {
      subscribe: {
        id: 1514,
        name: 'widget.statistic.subscribe',
      },
      activity: {
        send: {
          id: 1505,
          name: 'widget.statistic.activity.send',
          error() {
            throw new Error(this.name);
          },
        },
      },
      counters: {
        emptyCtToken: {
          id: 1506,
          name: 'widget.statistic.counters.emptyCtToken',
          severity: 30,
          error() {
            throw new Error(this.name);
          },
        },
        send: {id: 1007, name: 'widget.statistic.counters.send'},
      },
    },
    content: {
      scripts: {
        wix: {
          id: 1508,
          name: 'widget.content.scripts.wix',
          error() {
            throw new Error(this.name);
          },
        },
        player: {
          id: 1509,
          name: 'widget.content.scripts.player',
          error() {
            throw new Error(this.name);
          },
        },
        coreJs: {
          id: 1510,
          name: 'widget.content.scripts.coreJs',
          error() {
            throw new Error(this.name);
          },
        },
      },
    },
    init: {
      initial: {
        id: 1511,
        name: 'widget.init.initial',
        error() {
          throw new Error(this.name);
        },
      },
      reinit: {
        id: 1512,
        name: 'widget.init.reinit',
        error() {
          throw new Error(this.name);
        },
      },
      statisticSubscribe: {
        id: 1513,
        name: 'widget.init.statisticSubscribe',
        error() {
          throw new Error(this.name);
        },
      },
    },
  },
};
